const { SET_PAGE, SET_TOTAL_PAGE } = require("./actionTypes")

const initialState = {
  page: 1,
  totalPage: 0,
}

const paginate = (state = initialState, action) => {
  switch(action.type) {
    case SET_PAGE:
      state = { ...state, page: action.payload}
      break
    case SET_TOTAL_PAGE:
      state = { ...state, totalPage: action.payload}
      break
    default:
      state = { ...state}
      break
  }

  return state
}

export default paginate